import React from 'react';
import { css } from '@bts-web/utils-style-engine';
import { SVGIconType } from '../types';

const RegularDiscover: React.FC<SVGIconType> = ({
  color,
  size = 22,
  width,
  height,
  className,
  ...restProps
}) => {
  const wrapperClassName = css({
    color: color || 'neutrals.text_primary',
    display: 'inline-flex',
    alignItems: 'center',
    justifyContent: 'center',
    width: width || size,
    height: height || size,
  });

  return (
    <span
      data-testid="icon_discover"
      className={
        className ? `${wrapperClassName} ${className}` : wrapperClassName
      }
      data-element="icon"
      aria-label="discover icon"
      {...restProps}
    >
      <svg
        viewBox="0 0 24 24"
        xmlns="http://www.w3.org/2000/svg"
        width={`${size}px`}
        height={`${size}px`}
        fill="currentcolor"
      >
        <path d="M14.5882 2.34074C12.8926 1.88642 11.1074 1.88642 9.41181 2.34074C7.71626 2.79506 6.17016 3.6877 4.92893 4.92893C3.6877 6.17016 2.79506 7.71626 2.34074 9.41181C1.88642 11.1074 1.88642 12.8926 2.34074 14.5882C2.44795 14.9883 2.8592 15.2257 3.2593 15.1185C3.6594 15.0113 3.89684 14.6001 3.78963 14.2C3.40346 12.7587 3.40346 11.2413 3.78963 9.80004C4.1758 8.35882 4.93455 7.04464 5.98959 5.98959C7.04464 4.93455 8.35882 4.1758 9.80004 3.78963C11.2413 3.40346 12.7587 3.40346 14.2 3.78963C14.6001 3.89684 15.0113 3.6594 15.1185 3.2593C15.2257 2.8592 14.9883 2.44795 14.5882 2.34074Z" />
        <path d="M12 12.75C12.4142 12.75 12.75 12.4142 12.75 12C12.75 11.5858 12.4142 11.25 12 11.25C11.5858 11.25 11.25 11.5858 11.25 12C11.25 12.4142 11.5858 12.75 12 12.75Z" />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M21.3618 4.36665C22.0938 3.23544 20.7645 1.90617 19.6333 2.63812L9.53939 9.16947C9.39115 9.26539 9.26491 9.39163 9.16899 9.53987L2.63764 19.6338C1.90568 20.765 3.23497 22.0943 4.36617 21.3623L14.4601 14.831C14.6083 14.735 14.7345 14.6088 14.8305 14.4606L21.3618 4.36665ZM10.3992 10.3997L19.4687 4.53127L13.6002 13.6007L4.53079 19.4692L10.3992 10.3997Z"
        />
        <path d="M19.0711 19.0711C17.8298 20.3123 16.2837 21.2049 14.5882 21.6593C12.8926 22.1136 11.1074 22.1136 9.41181 21.6593C9.01171 21.5521 8.77427 21.1408 8.88148 20.7407C8.98869 20.3406 9.39994 20.1032 9.80004 20.2104C11.2413 20.5965 12.7587 20.5965 14.2 20.2104C15.6412 19.8242 16.9554 19.0655 18.0104 18.0104C19.0655 16.9554 19.8242 15.6412 20.2104 14.2C20.5965 12.7587 20.5965 11.2413 20.2104 9.80004C20.1032 9.39994 20.3406 8.98868 20.7407 8.88148C21.1408 8.77427 21.5521 9.01171 21.6593 9.41181C22.1136 11.1074 22.1136 12.8926 21.6593 14.5882C21.2049 16.2837 20.3123 17.8298 19.0711 19.0711Z" />
      </svg>
    </span>
  );
};

export { RegularDiscover };
